/**
 * Home Scene
 *
 * The central hub after entering. Three pathways branch from here:
 * MUSIC, DRIP, MORE — and the central "GO DEEPER?" call to action.
 */

import type { Scene } from '@/types/scene';

export const home: Scene = {
  id: 'home',
  name: 'Home',
  atmosphere: {
    background: 'linear-gradient(180deg, #0a0a0f 0%, #12121e 100%)',
    ambientAudio: '/audio/ambient/neon-dreams.mp3',
    fogIntensity: 0.3,
    noiseHue: 0,
    noiseBrightness: 0.6,
    noiseOpacity: 0.45,
  },
  interactions: [
    {
      id: 'nav-music',
      target: '[data-interaction="nav-music"]',
      action: { type: 'navigate', sceneId: 'music' },
    },
    {
      id: 'nav-drip',
      target: '[data-interaction="nav-drip"]',
      action: { type: 'navigate', sceneId: 'drip' },
    },
    {
      id: 'nav-more',
      target: '[data-interaction="nav-more"]',
      action: { type: 'navigate', sceneId: 'more' },
    },
    {
      id: 'go-deeper',
      target: '[data-interaction="go-deeper"]',
      action: { type: 'navigate', sceneId: 'go-deeper' },
    },
  ],
  transitions: [
    { to: 'music', effect: 'fade', duration: 800 },
    { to: 'drip', effect: 'fade', duration: 800 },
    { to: 'more', effect: 'fade', duration: 800 },
    { to: 'go-deeper', effect: 'fade', duration: 1200 },
  ],
  render: () => `
    <div class="home-center">
      <span class="go-deeper-cta" data-interaction="go-deeper">GO DEEPER?</span>
    </div>
  `,
};
